// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Media,
  Container,
  Row,
  Label,
  Form,
  FormGroup,
  Input,
  CardBody,
  CardTitle,
  Col,
  NavLink,
  Button,
  Badge,
} from "reactstrap";
import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";

//data
import {
  ResellerOrder,
  GAME_DETAIL_API,
  VerifyGameId,
  USER_DETAIL,
  DeletePreOrder,
} from "../../services/CONSTANTS";
import {
  getApiDataService,
  postApiDataService,
  deleteApiDataService,
} from "../../services/apiServices";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import {
  ConfirmDialog,
  DataTable,
  FilterBar,
  TablePagination,
} from "components/shared";

import Debounce from "./Util/Debounce";
import { set } from "lodash";
import { bindNiceSelect } from "utils/NiceSelectUtils";
import "../../utils/NiceSelect.css";
import useDebounce from "./Util/Debounce";
import { toast } from "react-toastify";
import { getAuthUserDetail } from "../../services/BusinessFlow/UserService";
import ResellerDetailModal from "./Util/ResellerDetailModal";

const Reseller = () => {
  const [preorders, setPreorders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [shortcut, setShortcut] = useState(null);
  const [userGameId, setUserGameId] = useState(null);
  const [zoneId, setZoneId] = useState(null);
  const [itemName, setItemName] = useState("");
  const [phone, setPhone] = useState(null);
  const [balance, setBalance] = useState(null);
  const [itemNames, setItemNames] = useState([]);
  const [count, setCount] = useState(1);
  const [type, setType] = useState("direct");

  const [total, setTotal] = useState(null);

  const [verifyResult, setVerifyResult] = useState("");

  const [status, setStatus] = useState(null);
  const [selectedType, setSelectedType] = useState("direct");
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetaileModal, setShowDetailModal] = useState(false);
  const [item, setitem] = useState(null);

  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const debounceGameId = useDebounce(userGameId, 1000);
  const debounceZoneId = useDebounce(zoneId, 1000);
  const [formVali, setFormVali] = useState(1);
  const [viewHistory, setViewHistory] = useState(false);

  const debounceShortcut = useDebounce(shortcut, 1000);
  const [dateChangeEvent, setDateChangeEvent] = useState(true);

  const clearForm = () => {
    console.log("clear form ");
    // setUserGameId("");
    // setZoneId("");
    setItemName("");
    setPhone("");
    setVerifyResult("");
    setCount(1);
    setShortcut("");
  };
  //   const []
  const [date, setDate] = useState("");

  const [startDate, setStartDate] = useState(
    moment().startOf("day").toISOString()
  );
  const [endDate, setEndDate] = useState(moment().endOf("day").toISOString());

  // useEffect(() => {
  //   console.log(itemNames)
  //   if (itemNames.length > 0) {
  //     const el = document.getElementById("a-select");
  //     bindNiceSelect(el);
  //   }
  // }, [itemNames]);

  useEffect(() => {
    if (debounceGameId && debounceZoneId) {
      fetchVerifyGameId();
    }
  }, [debounceGameId, debounceZoneId]);

  function debounce(func, delay) {
    let inDebounce;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
  }

  useEffect(() => {
    // setDate(moment().format("YYYY-MM-DD"));
    fetchResellerOrders();
  }, [
    dateChangeEvent,
    status,
    debounceSearch,
    page,
    selectedType,
    viewHistory,
  ]);

  useEffect(() => {
    fetGameUnitPrice();
    fetchUserDetail();
  }, []);

  useEffect(() => {
    if (debounceShortcut) {
      const regex = /^[0-9]+(\s[0-9]+ (\d{2}|wp|tw) 1)?$/;
      if (regex.test(debounceShortcut) == false) {
        // alert("Invalid Shortcut");
        toast.success("Invalid Shortcut");
      } else {
        let array = debounceShortcut.split(" ");
        console.log("Shortcut arr", array);
        let gameId = array[0];
        let zoneId = array[1];
        let dia = array[2];
        let count = array[3];

        setUserGameId(gameId);
        setZoneId(zoneId);
        if (dia == "wp") {
          setItemName("Weekly Pass");
        } else if (dia == "tp") {
          setItemName("Twilight Pass");
        } else {
          setItemName(dia);
        }
        setCount(count);
      }
    }
  }, [debounceShortcut]);

  let fetchResellerOrders = () => {
    setIsLoading(true);
    let api =
      ResellerOrder +
      `?&start_date=${startDate}&end_date=${endDate}&perPage=10&page=${page}`;
    api += debounceSearch ? `&search=${debounceSearch}` : "";
    api += status ? `&status=${status}` : "";
    api += selectedType ? `&type=${selectedType}` : "";
    getApiDataService(api)
      .then((res) => {
        console.log("res.data=", res.data);
        if (res?.meta) {
          setTotal(res.meta?.total);
          let totalPages = Number(
            Math.ceil(res.meta?.total / res.meta?.perPage)
          );
          let fromPages = Number(
            res.meta?.perPage * Number(res.meta?.page) -
              Number(res.meta?.perPage)
          );
          setFrom(fromPages + 1);
          setTotalPage(totalPages);
        }
        setPreorders(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setPreorders([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  let fetchUserDetail = () => {
    getAuthUserDetail()
      .then((res) => {
        console.log("fetchUserDetail", res);
        let total_amt = res.data?.wallets.find(wallet=>wallet.currency == "SmileCoin").unit_amount;
        setBalance(total_amt);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let fetGameUnitPrice = () => {
    // let ml_game_id = "64a47b11c9ff4e256d205815"; // dev
    let ml_game_id = process.env.REACT_APP_ENV=='production'?'649ef8db2f7c0933b90549f8':'649ef8db2f7c0933b90549f8' // prod:dev

    getApiDataService(GAME_DETAIL_API(ml_game_id))
      .then((res) => {
        let item_prices = filterPriceList(res.data, ["app", "pos"]);
        // remove item_name = 86,22
        item_prices = item_prices.filter(
          (item) => item.item_name != "11" && item.item_name != "22" && item.item_name != "56" && item.item_name != "112"
        )
        .sort((a, b) => {
          const aHasPlus = a.item_name.includes('+');
          const bHasPlus = b.item_name.includes('+');
          
          if (aHasPlus && !bHasPlus) return -1;
          if (!aHasPlus && bHasPlus) return 1;
          return 0;
        });
        
        setItemNames(item_prices);
        //   setPaymentAccounts(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        //   setPaymentAccounts([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  let fetchVerifyGameId = () => {
    setVerifyResult(null);
    postApiDataService(
      VerifyGameId,
      {
        user_game_id: userGameId,
        zone_id: zoneId,
        game_name:'Mobile Legends'
      },
      false
    )
      .then((res) => {
        let status = res.status;
        console.log("verify", res);
        if (status == 200) {
          setVerifyResult(`${res.username}`);
        } else {
          setVerifyResult("User Not Found!");
        }
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        //   setPaymentAccounts([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const filterPriceList = (game_data, types) => {
    let price_list = [];
    if (types.includes("app")) {
      price_list = price_list.concat(
        game_data.item_prices?.filter((item) => item.types.includes("app"))
      );
    }
    if (types.includes("pos")) {
      price_list = price_list.concat(
        game_data.item_prices?.filter((item) => item.types.includes("pos"))
      );
      console.log("pos price list", price_list);
    }
    //remove duplicate id
    price_list = price_list.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id)
    );

    //remove duplicate item_name
    price_list = price_list.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.item_name === item.item_name)
    );

    //sort by price_amount
    price_list.sort((a, b) => a.price_amount - b.price_amount);

    return price_list;
  };

  let handleSave = () => {
    let data = {
      user_game_id: userGameId,
      zone_id: zoneId,
      item_name: itemName,
      count: count,
      game_user_name: verifyResult,
      type: type,
    };
    console.log(data);
    setBtnLoading(true);
    postApiDataService(ResellerOrder, data)
      .then((res) => {
        // console.log("res.data=", res.data);
        setBtnLoading(false);
        clearForm();
        // fetchResellerOrders();
        fetchUserDetail();
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setBtnLoading(false);
      });
  };

  const handleModalBoxCancel = () => {
    setShowConfirmModal(false);
    setShowDeleteModal(false);
  };

  const handleDirectTopup = () => {
    console.log("start");
    // postApiDataService(StartTopupPreOrder, null)
    //   .then((res) => {
    //     console.log("handleDirectTopup res.data=", res.data);
    //     setBtnLoading(false);
    //     fetchResellerOrders();
    //     handleModalBoxCancel();
    //   })
    //   .catch((err) => {
    //     console.log("Error in useEffect!", err);
    //     setBtnLoading(false);
    //   });
  };

  const handleCallback = (start, end, label) => {
    console.log(start.toISOString(), "startDate1");
    console.log(end.toISOString(), "EndDate2");
    // moment('2020-06-05').format('YYYY-MM-DDTHH:mm:ssZ')
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());

    setDateChangeEvent(!dateChangeEvent);
  };

  const handleDateChange = (e) => {
    console.log("date change", e.target.value);
    let date = e.target.value;

    if(date=="today"){
      setStartDate(moment().startOf('day').toISOString());
      setEndDate(moment().endOf('day').toISOString());
    }else if(date=="yesterday"){
      setStartDate(moment().subtract(1, 'days').startOf('day').toISOString());
      setEndDate(moment().subtract(1, 'days').endOf('day').toISOString());
    }
    else if(date=="thisweek"){
      setStartDate(moment().startOf('week').toISOString());
      setEndDate(moment().endOf('week').toISOString());
    }
    else if(date=="lastweek"){
      setStartDate(moment().subtract(1, 'weeks').startOf('week').toISOString());
      setEndDate(moment().subtract(1, 'weeks').endOf('week').toISOString());
    }
    else if(date=="thismonth"){
      setStartDate(moment().startOf('month').toISOString());
      setEndDate(moment().endOf('month').toISOString());
    }
    else if(date=="lastmonth"){
      setStartDate(moment().subtract(1, 'months').startOf('month').toISOString());
      setEndDate(moment().subtract(1, 'months').endOf('month').toISOString());
    }
    else if(date=="all"){
      setStartDate(moment().subtract(1, 'years').startOf('year').toISOString());
      setEndDate(moment().endOf('day').toISOString());
    }

    setDateChangeEvent(!dateChangeEvent);
  };

  const handleDeleteClick = (item) => {
    setitem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    setIsLoading(true);
    console.log("Deleting item", item.id);
    deleteApiDataService(DeletePreOrder(item.id))
      .then((res) => {
        console.log("Delete success", res);
        fetchResellerOrders();
        handleModalBoxCancel();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in delete!", err);
      });
  };

  const handleDetailBtn = (item) => {
    console.log("detail item ", item);
    setitem(item);
    setShowDetailModal(true);
  };

  let deviceWidth = window.innerWidth;

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col-12 mb-lg-3 mt--5">
            <Card Card className="card-stats mb-4 mb-lg-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle className="text-uppercase text-muted mb-0">
                      Total Balance
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0">
                      {balance?.toLocaleString("en-US")}
                    </span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                      {/* <i className="fas fa-chart-bar" /> */}
                      <i class="fas fa-solid fa-coins"></i>
                    </div>
                  </Col>
                </Row>
                {/* <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  <i className="fa fa-arrow-up" />
                  3.48%
                </span>
                <span className="text-nowrap">Since last month</span>
              </p> */}
              </CardBody>
            </Card>
          </div>
        </Row>
        <Row>
          <div className="col-12">
            <Card className="shadow mb-4">
              <CardHeader className="border-0">
                <div className="d-flex align-items-center justify-content-between">
                  <h3 className="mb-0">
                    {/* {formVali ? "Reseller Form" : "Pre Order Lists"} */}
                    Topup Form
                  </h3>
                  <div>
                    <Badge
                      pill
                      color={formVali ? "primary" : "secondary"}
                      className={`px-3 py-2 px-md-4 py-md-3 text-${
                        formVali ? "white" : "dark"
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => setFormVali(1)}
                    >
                      Topup Dia
                    </Badge>
                    <Badge
                      pill
                      color={!formVali ? "primary" : "secondary"}
                      className={`px-3 py-2 px-md-4 py-md-3 text-${
                        !formVali ? "white" : "dark"
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFormVali(0);
                        setViewHistory(!viewHistory);
                      }}
                    >
                      History
                    </Badge>
                  </div>
                </div>
                {!formVali && (
                  <FilterBar className="mt-2">
                    <DateRangePicker
                      onCallback={handleCallback}
                      // initialSettings={{ startDate: moment(startDate,'YYYY-MM-DD').format('MM/DD/YYYY'), endDate: moment(startDate,'YYYY-MM-DD').format('MM/DD/YYYY') }}
                    >
                      <input
                        style={{ width: "200px" }}
                        className="form-control"
                        placeholder="Select date range"
                        aria-label="Date range"
                      />
                    </DateRangePicker>
                    <Input
                      className="w-auto"
                      type="select"
                      // value={status}
                      onChange={handleDateChange}
                      aria-label="Quick date range"
                    >
                      <option value="today">Today </option>
                      <option value="yesterday">Yesterday </option>
                      <option value="thisweek">This Week </option>
                      <option value="lastweek">Last Week </option>
                      <option value="thismonth">This Month </option>
                      <option value="lastmonth">Last Month </option>
                      <option value="all">All </option>
                    </Input>
                    <Input
                      name="orderId"
                      style={{ width: "200px" }}
                      placeholder="Search GameID"
                      aria-label="Search by game ID"
                      type="number"
                      onChange={(e) =>
                        debounce(setSearch(e.target.value), 1000)
                      }
                    />
                  </FilterBar>
                )}
              </CardHeader>
              {formVali ? (
                <>
                  <CardBody>
                    <Form>
                      {/* <Row>
                        <div className="col-12 col-md-12">
                          <FormGroup className="mb-2">
                            <Label for="userGameId">
                              Shortcut (GameID ZoneID Dia Count)
                            </Label>
                            <Input
                              type="text"
                              name="shortcut"
                              id="shourtcut"
                              value={shortcut}
                              onChange={(e) => setShortcut(e.target.value)}
                              placeholder="1459870574 16090 86 1"
                              // onChange={(e) => setUserGameId(e.target.value)}
                            />
                          </FormGroup>
                        </div>
                      </Row> */}
                      <Row>
                        <div className="col-6 col-md-6">
                          <FormGroup className="mb-2">
                            <Label for="userGameId">Game ID</Label>
                            <Input
                              type="tel"
                              name="userGameId"
                              id="userGameId"
                              value={userGameId}
                              onChange={(e) =>
                                debounce(setUserGameId(e.target.value), 1000)
                              }
                              // onChange={(e) => setUserGameId(e.target.value)}
                            />
                          </FormGroup>
                        </div>
                        <div className="col-6 col-md-6">
                          <FormGroup className="mb-2">
                            <Label for="zoneId">Zone ID</Label>
                            <Input
                              type="tel"
                              name="zoneId"
                              id="zoneId"
                              value={zoneId}
                              onChange={(e) =>
                                debounce(setZoneId(e.target.value), 1000)
                              }
                              // onChange={(e) => setZoneId(e.target.value)}
                            />
                          </FormGroup>
                        </div>
                      </Row>

                      <Row>
                        <div className="col-12">
                          <div className="text-center">
                            <h3 className="mb-2">
                              {verifyResult == null
                                ? "Checking..."
                                : verifyResult}
                            </h3>
                          </div>
                        </div>
                      </Row>

                      <Row>
                        <div className="col-12 col-md-12">
                          <FormGroup className="mb-0">
                            <Label for="a-select">Choose Item</Label> {itemName}
                            <select
                              className="form-control sampleClass"
                              id="a-select"
                              placeholder="Select Item"
                              value={itemName}
                              onChange={(e) => setItemName(e.target.value)}
                            >
                              <option key="0" value={null}>
                                Select
                              </option>
                              {itemNames.map((item, index) => (
                                <option key={index} value={item.item_name}>
                                  {item.item_name}
                                </option>
                              ))}
                            </select>
                          </FormGroup>
                        </div>
                        {/* <div className="col-6 col-md-6">
                          <FormGroup className="mb-0">
                            <Label for="count">Count</Label>
                            <Input
                              type="number"
                              name="count"
                              id="count"
                              value={count}
                              onChange={(e) => setCount(e.target.value)}
                              // onChange={(e) => setUserGameId(e.target.value)}
                            />
                          </FormGroup>
                        </div> */}
                      </Row>
                    </Form>
                  </CardBody>
                  <CardFooter className="text-right mt-0">
                    <button
                      className="btn btn-primary"
                      onClick={handleSave}
                      disabled={
                        btnLoading ||
                        verifyResult == null ||
                        verifyResult == "User Not Found!"
                      }
                    >
                      {btnLoading ? "Processing..." : "Topup"}
                    </button>
                  </CardFooter>
                </>
              ) : (
                <>
                  {(() => {
                    const columns =
                      deviceWidth > 420
                        ? [
                            {
                              key: "orderNo",
                              label: "Order No",
                              className: "px-2 text-center",
                            },
                            {
                              key: "gameAccount",
                              label: "Game Account",
                              className: "px-2 text-center",
                            },
                            {
                              key: "itemName",
                              label: "ItemName",
                              className: "px-2 text-center",
                            },
                            {
                              key: "count",
                              label: "Count",
                              className: "px-2 text-center",
                            },
                            {
                              key: "createdAt",
                              label: "Created At",
                              className: "px-2 text-center",
                            },
                            { key: "actions", label: "" },
                          ]
                        : [
                            {
                              key: "orderNo",
                              label: "Order No",
                              className: "px-2 text-center",
                            },
                            {
                              key: "gameAccount",
                              label: "Game Account",
                              className: "px-2 text-center",
                            },
                            {
                              key: "itemName",
                              label: "ItemName",
                              className: "px-2 text-center",
                            },
                            { key: "actions", label: "" },
                          ];
                    return (
                      <DataTable
                        columns={columns}
                        data={preorders}
                        isLoading={isLoading}
                        emptyMessage="No records found"
                        renderRow={(item, index) => (
                          <tr key={item?.id ?? index}>
                            <td
                              className="px-2 text-center font-mono"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              #{item.order_no}
                            </td>
                            <td
                              className="px-2 text-center"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {item.game_user_name} <br />
                              <strong>
                                {item.user_game_id} ({item.zone_id})
                              </strong>
                            </td>
                            <td className="px-2 text-center">
                              {item.item_name}{" "}
                            </td>
                            {deviceWidth > 420 && (
                              <>
                                <td
                                  className="px-2 text-center"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  {item.count}{" "}
                                </td>
                                <td
                                  className="px-2 text-center"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  {moment(item.date).format(
                                    "YYYY-MM-DD hh:mm:ss a"
                                  )}
                                </td>
                              </>
                            )}
                            <td
                              className="px-2 text-center"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              <Button
                                color="primary"
                                size="sm"
                                outline
                                type="button"
                                onClick={() => handleDetailBtn(item)}
                              >
                                Detail
                              </Button>
                            </td>
                          </tr>
                        )}
                      />
                    );
                  })()}
                  <TablePagination
                    meta={{ total, perPage: 10 }}
                    page={page}
                    setPage={setPage}
                  />
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      {showConfirmModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Confirm"
          message="Are you sure you want to Topup this orders?"
          confirmText="Yes"
          confirmColor="success"
          isLoading={isLoading}
          onConfirm={handleDirectTopup}
        />
      )}

      {showDeleteModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Delete"
          message="Are you sure you want to delete this item?"
          confirmText="Yes"
          confirmColor="danger"
          isLoading={isLoading}
          onConfirm={handleDeleteConfirm}
        />
      )}

      {showDetaileModal && (
        <ResellerDetailModal
          item={item}
          aa="aa"
          onClose={() => setShowDetailModal(false)}
        />
      )}
    </>
  );
};

export default Reseller;
